import React from 'react'

// Components
import Header from '../components/Header'
import Footer from '../components/Footer'
import VideoCard from '../components/Card/Video'
import Button from '../components/Commons/Button'

const headingTag = {
  width: 65,
  height: 4,
  display: 'block',
  margin: '0 auto',
  backgroundImage: 'linear-gradient(to right, #000000 0%, #5d59d2 100%)',
}

const headingTitle = {
  color: '#34383b',
  fontSize: '1.5rem',
  fontWeight: 700,
  lineHeight: '2.25rem',
  marginBottom: '60px'
}

const gestaoPage = () =>
  <div>
    <Header name="site-header" style={{paddingBottom: '150px', marginBottom: '-130px'}}>
      <div className="container">
        <div className="grid-center">
           <div className="col-8_md-10 grid-column content center">
             <h1>
               Extraia o melhor do Talkative
             </h1>
             <p>O Talkative conta com um excelente time de colaboradores e parceiros para garantir a melhor ferramenta para a sua empresa ou organização.</p>
           </div>
        </div>
      </div>
    </Header>
    <section className="tutoriais-section" style={{marginBottom: '100px'}}>
      <div className="container"
        style={{
          backgroundColor: '#fff',
          borderRadius: '0.5rem',
          padding: '50px 30px'}}>
        <div className="grid-1">
          <div className="col text-center">
            <span style={headingTag}></span>
            <h6 style={headingTitle}>Vídeo tutoriais</h6>
          </div>

          <div className="col">
            <VideoCard />
            <VideoCard />
            <VideoCard />
            <VideoCard />
          </div>
        </div>
      </div>
      <div className="container text-center" style={{marginTop: '100px'}}>
        <Button name="green" text="Carregar mais" />
      </div>
    </section>
    <Footer />
  </div>

export default gestaoPage



// WEBPACK FOOTER //
// ./src/pages/tutoriais.js